(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = [];

    function DashboardController() {
        var vm = this;
        vm.applyFilter = applyFilter;

        vm.fleet = {};
        vm.objectType = {};

        function applyFilter(fleet, objectType) {
            vm.fleet = fleet;
            vm.objectType = objectType;
        }
    }
})();
